import React from 'react';
import ErrorIcon from '../assets/img/error.svg';
import {ChakraProvider, theme, Text, Flex, Image, Button} from "@chakra-ui/react";

const RejectSelfieCard = props =>{
  
    return(
      <ChakraProvider theme={theme}>
        <Flex alignItems="center" justifyContent="center" w="100vW" h="100vH" position="fixed" zIndex="911" bg="white" flexDirection="column">
        <Text
        color="#222222"
        fontSize="24px"
        fontWeight="700">
        Hi 🙂
        </Text>
        { (props.error) ? <Text
        color="#C51162"
        fontSize="15px"
        fontWeight="400">
        {!props.error}
        </Text> : null }

        <Image 
          mt="4"
          src={props.image}
          alt="Loader Icon"
          borderRadius="100"
          w="200px"
          h="200px"
          objectFit="contain"
        />

        { (!props.error) ? <Flex
         mt="140"
         alignItems="center"
         justifyContent="center"
         ml="150"
         w="32px"
         h="32px"
         bg="#e2e8f0"
         boxShadow="0px 3px 16px 0px rgba(87,80,80,0.89)"
         borderRadius="40"
         position="absolute">
       
         <Image 
         src={ErrorIcon}
         alt="Select Img"
         w="32px"
         h="32px"
         zIndex="1"
         />
         </Flex>
         : null }
        <Flex
        alignItems="center"
        justifyContent="center"
        mt="12">
        <Button
        bg="#FA2F45"
        borderRadius="40"
        pl="6"
        pr="6"
        color="white"
        fontSize="14px"
        fontWeight="400"
        onClick={() => props.ClickAgain(true)}>
        Click again
        </Button>
        </Flex>
        </Flex>
    </ChakraProvider>
)}
export default RejectSelfieCard;

